import React, {useEffect} from 'react';
import {Sector} from "../../../services/models/sector";
import Select, {components, SingleValue, StylesConfig} from "react-select";
import {DropdownIndicator} from "../../shared/DropdownIndicator";
import {customStyles, SelectOption} from "../../shared/selectStyles";

// Расширяем базовые стили для SectorSelect
const sectorSelectStyles: StylesConfig<SelectOption, false> = {
    ...customStyles,
    menuList: (provided, state) => {
        const baseStyles = customStyles.menuList?.(provided, state) || provided;
        return {
            ...baseStyles,
            maxHeight: '500px',
            overflowY: 'auto',
        };
    },
    valueContainer: (provided, state) => ({
        ...provided,
        backgroundColor: state.isDisabled ? "#E0E0E0 !important" : "#FFF !important",
        background: state.isDisabled ? "#E0E0E0 !important" : "#FFF !important",
    })
};

interface SectorSelectProps {
    sectors?: Sector[];
    selected?: string | null;
    onSectorChange?: (sectorId: string) => void;
    disabled?: boolean | null;
    isAdmin?: boolean;
}

export const SectorSelect: React.FC<SectorSelectProps> = ({sectors, selected, onSectorChange, disabled = false, isAdmin}) => {
    const isInitialMount = React.useRef(true);
    const sectorOptions: SelectOption[] = React.useMemo(() => {
        if (!sectors || sectors.length === 0) {
            return [];
        }

        const options = sectors
            .map(sector => {
                if (!sector.id) {
                    console.error('Sector object does not have id field:', sector);
                    return null;
                }

                return {
                    value: sector.id,
                    label: sector.name,
                    fullLabel: sector.name
                };
            })
            .filter((option): option is SelectOption => option !== null);
        return options;
    }, [sectors]);
    
    useEffect(() => {
        if (isInitialMount.current && sectorOptions.length > 0 && !selected && onSectorChange && isAdmin) {
            onSectorChange(sectorOptions[0].value);
        }
        isInitialMount.current = false;
    }, [sectorOptions, selected, onSectorChange, isAdmin]);

    // Находим выбранный option
    const selectedOption = selected ? sectorOptions.find(opt => opt.value === selected) : null;

    return (
        <Select
            isMulti={false}
            classNamePrefix="select"
            name="sectors"
            options={sectorOptions}
            isSearchable={true}
            isClearable={false}
            isDisabled={disabled || false}
            placeholder={"Выберите регион"}
            noOptionsMessage={() => "Нет доступных опций"}
            components={{
                IndicatorSeparator: () => null,
                DropdownIndicator,
                Option: components.Option
            }}
            hideSelectedOptions={false}
            closeMenuOnSelect={true}
            blurInputOnSelect={true}
            value={selectedOption as SingleValue<SelectOption>}
            onChange={(newValue: SingleValue<SelectOption>) => {
                if (onSectorChange && newValue) {
                    onSectorChange(newValue.value);
                }
            }}
            styles={sectorSelectStyles}
        />
    )
};
